import { getRolesState } from './roles.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  SetDefaultData,
  UpdateField,
  FetchRolesRequest,
  DeleteRoleRequest,
} from './roles.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css'],
})
export class RolesComponent extends ListTrait implements OnInit, OnDestroy {
  private state$: Subscription
  private route$: Subscription
  private shouldReload: boolean
  public isLoading: boolean
  public columns: object[] = [
    {
      prop: 'name',
      name: 'NAME',
      sortable: true,
    },
    {
      prop: 'title',
      name: 'TITLE',
      sortable: true,
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store.pipe(select(getRolesState)).subscribe((state) => {
      this.state = state
      this.isLoading = state.get('isLoading')

      if (
        state.get('shouldReload') != this.shouldReload &&
        state.get('shouldReload')
      ) {
        this.runFilter()
      }
      this.shouldReload = state.get('shouldReload')
    })

    this.route$ = this.route.queryParams.subscribe(this.runFilter.bind(this))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
  }

  runFilter(queryParams: any = {}) {
    const { page, page_size } = this.state.get('queryParams').toJS()
    const params = { page, page_size, ...queryParams }

    this.store.dispatch<any>(
      new FetchRolesRequest({
        filters: {
          ...(params.keyword
            ? {
                or: [
                  { field: 'name', value: params.keyword },
                  { field: 'title', value: params.keyword },
                ],
              }
            : {}),
        },
        pageSize: parseInt(params.page_size, 10),
        page: parseInt(params.page, 10) - 1,
        sort: {
          order: params.sort?.toUpperCase(),
          prop: params.order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('queryParams', params, 'list'))
  }

  deleteRole(id: number) {
    this.store.dispatch(new DeleteRoleRequest(id))
  }
}
